<template>
  <v-app light>
    <v-content>
      <v-container fluid>
        <transition
          name="page"
          mode="out-in"
        >
          <router-view />
        </transition>
      </v-container>
    </v-content>
    <full-loading />
    <feedback-message />
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import FeedbackMessage from '~/components/FeedbackMessage'
import FullLoading from '~/components/FullLoading'

export default {
  name: 'plain-layout',
  components: {
    'feedback-message': FeedbackMessage,
    'full-loading': FullLoading
  },
  mounted () {
    this.$bus.$emit('refreshFontName', 'proxima-nova')
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/plain.vue